export default __webpack_public_path__ + "static/media/icon_7_on.5ed38ce9.png";